Vue.component('v-commonfoot',require('@/js/components/common/commonfoot.vue').default);
Vue.component('v-collections',require('@/js/components/view/collections/collections.vue').default);
Vue.component('v-collectionitem',require('@/js/components/view/collections/collectionitem.vue').default);
Vue.component('v-subscribe',require('@/js/components/common/subscribe.vue').default);

setTimeout(window.startup, 10);